// src/pages/PrivacyPage.js
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-header">
        <button className="page-title-btn" onClick={() => navigate('/')}>
          <img src="/logo.png?v=2" alt="" className="header-logo" />
          PlantID Game
        </button>
      </div>
      <div className="legal-content">
        <h1>Privacy Policy / Datenschutzerklärung</h1>

        <section className="legal-section">
          <h2>English</h2>

          <h3>1. Controller</h3>
          <p>The controller responsible for data processing on this website is:</p>
          <p>
            Laurids Radtke<br />
            Lehmbruckstraße 25<br />
            10245 Berlin<br />
            plantidentificationgame@gmail.com
          </p>

          <h3>2. Hosting</h3>
          <p>This website is hosted by Hostinger.</p>
          <p>When you visit this website, the server automatically processes the following data:</p>
          <ul>
            <li>IP address</li>
            <li>Date and time of access</li>
            <li>Accessed page/file</li>
            <li>Amount of data transferred</li>
            <li>Browser type and version</li>
            <li>Operating system</li>
          </ul>
          <p>
            This data is technically necessary to provide the website and to ensure its stability and security.
            The legal basis is Art.&nbsp;6(1)(f) GDPR (legitimate interest in secure and functional website operation).
          </p>

          <h3>3. Fonts</h3>
          <p>
            The fonts used on this website are hosted locally on our server.
            No connection to external font providers is established.
          </p>

          <h3>4. Cookies</h3>
          <p>This website does not use cookies.</p>

          <h3>5. External Services</h3>
          <p>No analytics, tracking, or marketing services are used.</p>

          <h3>6. Data Subject Rights</h3>
          <p>You have the right to:</p>
          <ul>
            <li>request access to your stored data</li>
            <li>request correction of inaccurate data</li>
            <li>request deletion of your data</li>
            <li>request restriction of processing</li>
            <li>object to processing</li>
            <li>lodge a complaint with a supervisory authority</li>
          </ul>

          <h3>7. Contact</h3>
          <p>
            If you contact us via email, the data you provide will be processed solely for the purpose of handling your request.
          </p>
        </section>

        <section className="legal-section">
          <h2>Deutsch</h2>

          <h3>1. Verantwortlicher</h3>
          <p>Verantwortlich für die Datenverarbeitung auf dieser Website:</p>
          <p>
            Laurids Radtke<br />
            Lehmbruckstraße 25<br />
            10245 Berlin<br />
            plantidentificationgame@gmail.com
          </p>

          <h3>2. Hosting</h3>
          <p>Diese Website wird bei Hostinger gehostet.</p>
          <p>Beim Aufruf der Website werden durch den Server automatisch folgende Daten verarbeitet:</p>
          <ul>
            <li>IP-Adresse</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Aufgerufene Seite/Datei</li>
            <li>Übertragene Datenmenge</li>
            <li>Browsertyp und Browserversion</li>
            <li>Betriebssystem</li>
          </ul>
          <p>
            Diese Daten sind technisch erforderlich, um die Website bereitzustellen sowie die Stabilität und Sicherheit zu gewährleisten.
            Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigtes Interesse an einem sicheren und funktionsfähigen Betrieb der Website).
          </p>

          <h3>3. Schriftarten</h3>
          <p>
            Die auf dieser Website verwendeten Schriftarten werden lokal auf unserem Server gehostet.
            Es erfolgt keine Verbindung zu externen Anbietern im Zusammenhang mit der Darstellung von Schriftarten.
          </p>

          <h3>4. Cookies</h3>
          <p>Diese Website verwendet keine Cookies.</p>

          <h3>5. Externe Dienste</h3>
          <p>Es werden keine Analyse-, Tracking- oder Marketingdienste eingesetzt.</p>

          <h3>6. Rechte der betroffenen Personen</h3>
          <p>Sie haben das Recht:</p>
          <ul>
            <li>Auskunft über Ihre gespeicherten Daten zu verlangen</li>
            <li>Berichtigung unrichtiger Daten zu verlangen</li>
            <li>Löschung Ihrer Daten zu verlangen</li>
            <li>Einschränkung der Verarbeitung zu verlangen</li>
            <li>Widerspruch gegen die Verarbeitung einzulegen</li>
            <li>Sich bei einer Datenschutzaufsichtsbehörde zu beschweren</li>
          </ul>

          <h3>7. Kontaktaufnahme</h3>
          <p>
            Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen übermittelten Daten ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPage;
